<template>
  <!-- 添加客服电话设置弹窗 -->
  <el-dialog title="客服电话设置" :visible="isShowType" @close='close' width='550px' :destroy-on-close="true"
    :close-on-click-modal='false'>
    <el-form :model="form" ref="addform" :rules="tableRules">
      <el-table ref="addTable" class="global-table" v-loading="loading" :data="form.tableData">
        <el-table-column label="公园名称" prop="projectId" min-width="100" align='center'>
          <template v-slot="{ row, $index }">
            <el-form-item v-if="$index === addLine" :prop="'tableData.' + $index + '.projectId'" :rules="tableRules.projectId">
              <el-select v-model="row.projectId" placeholder="请选择所属公园" filterable>
                <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
                  :value="item.projectId"></el-option>
              </el-select>
            </el-form-item>
            <div v-else>{{ row.projectName }}</div>
          </template>
        </el-table-column>

        <el-table-column label="呼叫对象" prop="typeName" min-width="100" align='center'>
          <template v-slot="{ row, $index }">
            <el-form-item v-if="$index === addLine" placeholder="请输入呼叫对象" :prop="'tableData.' + $index + '.typeName'"
              :rules="tableRules.typeName">
              <el-input v-model="row.typeName"></el-input>
            </el-form-item>
            <div v-else>{{ row.typeName }}</div>
          </template>
        </el-table-column>

        <el-table-column label="客服电话" prop="phone" min-width="100" align='center'>
          <template v-slot="{ row, $index }">
            <el-form-item v-if="$index === addLine" :prop="'tableData.' + $index + '.phone'" :rules="tableRules.phone">
              <el-input v-model="row.phone"></el-input>
            </el-form-item>
            <div v-else>{{ row.phone }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="100" align='center'>
          <template v-slot="{ row, $index }">
            <el-button type="text" v-if="$index === addLine" @click="onSave(row, $index)">保存</el-button>
            <template v-else>
              <el-button type="text" @click="onEdit(row, $index)" v-if="$ButtonShow('KFP_EDT_01')">编辑</el-button>
            </template>
            <el-button type="text" @click="onDelete(row, $index)" v-if="$ButtonShow('KFP_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-button type="text" @click='onAdd()' icon='el-icon-plus' v-if="$ButtonShow('KFP_ADD_01')">添加客服电话</el-button>
  </el-dialog>
</template>

<script>
import { validatePhoneAndFixedLine } from '@/utils/validate'
export default {
  typeName: 'ServiceType',
  props: {
    isShowType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addLine: null,
      loading: false,
      form: {
        tableData: []
      },
      parkList: [],
      tableRules: {
        projectId: [
          { required: true, message: '请选择公园名称', trigger: ['blur', 'change'] }
        ],
        typeName: [
          { required: true, message: '请输入呼叫对象', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入客服电话', trigger: ['blur', 'change'] },
          { validator: validatePhoneAndFixedLine, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created() {
    this.getPark()
  },
  watch: {
    isShowType: function (newValue, oldValue) {
      newValue && this.getTypeList()
    },
    deep: true
  },
  computed: {
  },
  methods: {
    validNotEdit(index) {
      if (this.addLine !== null) {
        if (this.addLine !== index) {
          this.$message.warning('请先保存')
        }
        return false
      }
      return true
    },
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    getTypeList() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectKfPhoneByPage).then(res => {
        this.form.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onAdd() {
      if (this.validNotEdit()) {
        this.form.tableData.push({
          projectId: '',
          typeId: '',
          phone: ''
        })
        this.addLine = this.form.tableData.length - 1
        this.$nextTick(() => {
          this.$refs.addTable.bodyWrapper.scrollTop = this.$refs.addTable.bodyWrapper.scrollHeight
        })
      }
    },
    onSave(row, index) {
      this.addLine = index
      this.$refs.addform.validate().then(() => {
        const url = row.id ? this.$apis.tourist.updateKfPhone : this.$apis.tourist.insertKfPhone
        const params = {
          projectId: row.projectId,
          typeName: row.typeName,
          phone: row.phone
        }
        this.$axios.post(url, row.id ? { ...params, id: row.id } : params).then(res => {
          this.$message.success('保存成功')
          this.getTypeList()
          this.addLine = null
        })
      })
    },
    onEdit(row, index) {
      if (this.validNotEdit(index)) {
        this.addLine = index
      }
    },
    onDelete(row, index) {
      if (this.validNotEdit()) {
        this.$confirm(`是否删除客服电话【${row.phone}】?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.tourist.deleteKfPhone,
            {
              id: row.id
            }).then(() => {
              this.$message.success('删除成功')
              this.addLine = null
              this.getTypeList()
            })
        })
      }
    },
    close() {
      this.addLine = null
      this.$emit('update:isShowType', false)
    }
  }
}
</script>
<style scoped lang="scss"></style>
